export default {
    subscriptionFinishedSuccessful: "Sie haben sich erfolgreich zu diesem Newsletter angemeldet!",
    subscriptionFinishedSuccessfulText: "Sie erhalten in Kürze eine E-Mail mit einem Bestätigungslink. Bitte klicken " +
        "Sie auf diesen Link, um Ihre Anmeldung abzuschließen.",
    subscriptionUpdatedSuccessful: "Ihre Daten wurden erfolgreich aktualisiert!",
    unsubscriptionFinishedSuccessful: "Sie wurden erfolgreich vom Newsletter abgemeldet",

    editSubscription: "Sie sind zu diesem Newsletter angemeldet.",
    newSubscription: "Sie melden sich zu diesem Newsletter an.",
    subscribe: "Anmelden",
    unsubscribe: "Von diesem Newsletter abmelden",
    chosenProfiles: "Ihre Interessen",
    updateSubscription: "Daten aktualisieren",
    subscriptionNotConfirmed: "E-Mail noch nicht bestätigt.",
    subscriptionNotConfirmedInfo: "Sie sollten nach Ihrer Anmeldung eine E-Mail mit einem Bestätigungslink an Ihre E-Mail " +
        "Adresse {email} bekommen haben. Falls Sie keine E-Mail erhalten haben wenden Sie sich bitte an den Herausgeber.",
    unsubscribeNow: "Jetzt abmelden",
    unsubscribeInfo: "Sie sind dabei die E-Mail Adresse {email} von diesem Newsletter und allen gewählten Profilen abzumelden. " +
        "Sobald Sie abgemeldet sind werden Ihre Daten gelöscht und Sie erhalten keine weiteren Mails zu diesem Newsletter. " +
        "Falls Sie sich zu einem späteren Zeitpunkt erneut anmelden, müssen Sie Ihre Mail Adresse erneut bestätigen.",

    selectedProfiles: "Ausgewählte Interessen",
    successfullyConfirmed: "Ihre E-Mail Adresse wurde erfolgreich bestätigt!",

    formData: {
        email: "E-Mail",
        phone: "Telefonnummer",
        iban: "IBAN",
        accountHolder: "Kontoinhaber",
        sendDonationReceipt: "Zuwendungsbescheinigung ausstellen",
        donationAmount: "Spendenbetrag",
        salutation: "Anrede",
        noSalutation: "Keine Anrede",
        firstname: "Vorname",
        lastname: "Nachname",
        country: "Land",
        street: "Strasse",
        houseNumber: "Hausnummer",
        houseNumberLabel: "Nummer",
        zip: "PLZ",
        city: "Stadt",

        noAppreciation: "Ich möchte kein Dankschreiben zu dieser Spende erhalten",

        acadTitle: "Titel",
        noTitle: "Kein Titel",
        toTheAttention: "Zu Händen",
        birthday: "Geburtsdatum",
        addressType: "Adressart",
        pleaseInputZipFirst: "Bitte zuerst PLZ eingeben",
        pleaseInputCityFirst: "Bitte zuerst einen Ort auswählen",
        pleaseInputStreetFirst: "Bitte zuerst eine Straße auswählen",

        chooseCity: "Ort wählen",
        noCitiesFound: "Es konnten keine Orte gefunden werden!",
        loadCities: "Lade Orte...",

        chooseStreet: "Straße wählen",
        loadStreets: "Lade Straßen...",
        noStreetsFound: "Es konnten keine Straßen gefunden werden!",

        postboxNumber: "Postfachnummer",

        addressAdditional: "Adresszusatz",

        isPostbox: "Adresse ist ein Postfach"
    }
}